import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { ChatBubble, EditOffSharp, EditSharp, UploadFile } from '@mui/icons-material';
import { useAuth } from '../../authentication/AuthContext';

// Icon mapping for backend icons
const iconMap = {
  'users': <EditSharp />,
  'documents': <EditOffSharp />,
  'analytics': <SettingsRoundedIcon />,
  'settings': <SettingsRoundedIcon />,
  'chat': <ChatBubble />,
  'activity': <SettingsRoundedIcon />,
  'dashboard': <HomeRoundedIcon />,
  'upload': <UploadFile />
};

export default function MenuContent() {
  const { dashboardData } = useAuth();
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {/* Dashboard link - always show */}
        <ListItem disablePadding sx={{ display: 'block' }}>
          <ListItemButton selected={true}>
            <ListItemIcon><HomeRoundedIcon /></ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        </ListItem>

        {/* Role-based menu items from backend */}
        {dashboardData?.sections?.map((section) => (
          <ListItem key={section.name} disablePadding sx={{ display: 'block' }}>
            <ListItemButton>
              <ListItemIcon>
                {iconMap[section.icon] || <EditOffSharp />}
              </ListItemIcon>
              <ListItemText primary={section.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
